<template>
<div>
  <b-dropdown
      position="is-bottom-left"
      class="NotificationBell"
      trigger="click"
  >

    <div
      class="is-light"
      slot="trigger"
      style="cursor: pointer;"
      @click="fetchCount();showPage1()"
    >
      <b-icon icon="notification"></b-icon>
      <span v-if="count > 0" class="notification-dot"></span>
    </div>
    <div class="py-2 px-4 is-flex is-align-items-center">
      <div class="is-flex-grow-1">
        Notifications
      </div>
      <div class="">
        <b-button @click="markAllAsRead()">
          Mark all as read
        </b-button>
      </div>
    </div>
    <div style="max-height: calc(100vh - 250px); overflow-y: auto; width: 450px">
      <template v-if="notificationsToday.length > 0">
        <b-dropdown-item has-header class="notification-header">
          <p style="font-weight: 600; font-size: 1rem; color: black;">Today</p>
        </b-dropdown-item>
        <template
            v-for="(notification) in notificationsToday"
        >
          <div @click="click(notification)" :key="notification.id">
            <NotificationItem  :notification="notification" @click="click(notification)"/>
          </div>
        </template>

      </template>

      <template v-if="notificationsOlder.length > 0">
        <b-dropdown-item has-header  class="notification-header">
          <p style="font-weight: 600; font-size: 1rem; color: black;">Older</p>
        </b-dropdown-item>
        <template
            v-for="(notification) in notificationsOlder"
        >
          <div @click="click(notification)" :key="notification.id">
            <NotificationItem  :notification="notification" @click="click(notification)"/>
          </div>
        </template>
      </template>

      <b-loading
          :active.sync="loading"
          :can-cancel="false"
          :is-full-page="false"
      />
    </div>

    <div class="has-text-centered py-2">
      <a :disable="disableShowMore" @click="showMore">
        Show more
      </a>
    </div>


  </b-dropdown>
</div>
</template>

<script>
import AvatarReminder from "@/components/notifications/AvatarReminder.vue";
import AvatarForum from "@/components/notifications/AvatarForum.vue";
import AvatarFeedback from "@/components/notifications/AvatarFeedback.vue";
import AvatarCourse from "@/components/notifications/AvatarCourse.vue";
import AvatarTask from "@/components/notifications/AvatarTask.vue";
import AvatarEvent from "@/components/notifications/AvatarEvent.vue";
import NotificationItem from "@/components/global/NotificationItem.vue";
import CourseItem from "@/components/courses/Course.vue";
import genexPanel from "@/components/global/genexPanel.vue";
import Notification from "@/models/lms/Notification";
import GenexHelperMixins from "@/mixins/GenexHelperMixins";
import Course from "@/models/lms/Course";
import AssessmentFeedback from "@/models/sis/AssessmentFeedback";
import JournalFeedback from "@/models/sis/JournalFeedback";
import LMSForumPost from "@/models/lms/LMSForumPost";
import Assessment from "@/models/sis/Assessment";
import AssessmentSubmission from "@/models/sis/AssessmentSubmission";
import LMSForumComment from "@/models/lms/LMSForumComment";

export default {
  name: "NotificationBell",
  components: {
    genexPanel,
    CourseItem,
    NotificationItem, AvatarEvent, AvatarTask, AvatarCourse, AvatarFeedback, AvatarForum, AvatarReminder},
  data(){
    return {
      disableShowMore: false,
      page: 1,
      limit: 10,
      loading: false,
      count: 0,
    }
  },
  computed: {
    notificationsToday() {
      const today = new Date();
      today.setHours(0, 0, 0, 0); // Reset time to start of day

      return Notification.query()
          .where(record => {
            const createdAt = new Date(record.created_at);
            return createdAt >= today;
          })
          .orderBy(record => new Date(record.created_at).getTime(), 'desc') // Order by 'created_at' in descending order (newest first)
          .get();
    },

    notificationsOlder() {
      const today = new Date();
      today.setHours(0, 0, 0, 0); // Reset time to start of day

      return Notification.query()
          .where(record => {
            const createdAt = new Date(record.created_at);
            return createdAt < today;
          })
          .orderBy(record => new Date(record.created_at).getTime(), 'desc') // Order by 'created_at' in descending order (newest first)
          .get();
    }

  },
  methods: {
    markAllAsRead(notification){
      Notification.MarkAllAsRead(this.$store.state.auth.user.id).then(()=>{
        this.fetchCount()
      })
    },
    async click(notification){

      const model = notification.data.model
      const model_id = notification.data.model_id
      let routeConf = {}
      let supportedRoute = true
      this.fetchCount()
      Notification.MarkAsReadById(this.$store.state.auth.user.id, notification.id)
      if (model == "Course") {
        routeConf = await this.routeConfForCourse(model_id);
      }
      else if (model == "Event") {
        routeConf = await this.routeConfForEvent(model_id);
      }
      else if (model == "AssessmentFeedback") {
        routeConf = await this.routeConfForAssessmentFeedback(model_id);
      }
      else if (model == "JournalFeedback") {
        routeConf = await this.routeConfForJournalFeedback(model_id);
      }
      else if (model == "ForumPost") {
        routeConf = await this.routeConfForForumPost(model_id);
      }
      else if (model == "ForumComment") {
        routeConf = await this.routeConfForForumComment(model_id);
      }
      else if (model == "Assessment") {
        routeConf = await this.routeConfForAssessment(model_id);
      } else {
        supportedRoute = false
      }
      if (supportedRoute){
        this.$router.push(routeConf).catch(() => {})
      }

    },
    async routeConfForCourse(model_id){
      return {
        name: "courses.view",
        params:  {
          courseId: model_id,
        },
      }
    },
    async routeConfForEvent(model_id){
      return {
        name: "dashboard",
        query: {
          currentEvent: model_id,
        }
      }

    },
    async routeConfForAssessmentFeedback(model_id){

      await AssessmentFeedback.FetchById(model_id, ["assessment_submission.assessment.subject"])
      const entity = AssessmentFeedback.query().whereId(model_id).with(["assessment_submission.assessment.subject"]).get()[0]
      return {
        name: "TaskSubmission",
        params:  {
          subjectId: entity.assessment_submission.assessment.subject.id,
          subjectName: entity.assessment_submission.assessment.subject.name,
          id: entity.assessment_submission.id,
          name: entity.assessment_submission.assessment.name,
        },
        query: {
          currentEvent: model_id,
        }
      }

    },
    async routeConfForJournalFeedback(model_id){

      await JournalFeedback.FetchById( model_id, ["journal_entry.class_group.subject"] )
      const entity = JournalFeedback.query().whereId(model_id).with(["journal_entry.class_group.subject"]).get()[0]
      return {
        name: "JournalsEdit",
        params:  {
          subjectId: entity.journal_entry.class_group.subject.id,
          subjectName: entity.journal_entry.class_group.subject.name,
          id: entity.journal_entry.id,
          name: entity.journal_entry.title,
        },
        query: {
          currentEvent: model_id,
        }
      }

    },
    async routeConfForForumPost(model_id){

      await LMSForumPost.FetchById(model_id, ["topic.forum"])
      const entity = LMSForumPost.query().whereId(model_id).with(["topic.forum"]).get()[0]
      return {
        name: "forum.index",
        query: {
          forumId: entity.topic.forum.id,
          forumTopicId: entity.topic.id,
          forumPostId: model_id,
        }
      }

    },
    async routeConfForForumComment(model_id){

      await LMSForumComment.FetchById(model_id, ["forumPost.topic.forum"])
      const entity = LMSForumComment.query().whereId(model_id).with(["forumPost.topic.forum"]).get()[0]
      return {
        name: "forum.index",
        query: {
          forumId: entity.forumPost.topic.forum.id,
          forumTopicId: entity.forumPost.topic.id,
          forumPostId: entity.forumPost.id,
        }
      }

    },
    async routeConfForAssessment(model_id){

      await AssessmentSubmission.FetchAll(model_id, {
        student_id: this.$store.state.auth.user.sis_user_id,
        assessment_id: model_id,
      }, ['assessment.subject'])
      const entity = AssessmentSubmission.query()
          .where("student_id", this.$store.state.auth.user.sis_user_id)
          .where("assessment_id", model_id)
          .with(['assessment.subject']).get()[0]
      return {
        name: "TaskSubmission",
        params:  {
          subjectId: entity.assessment.subject.id,
          subjectName: entity.assessment.subject.name,
          id: entity.id,
          name: entity.assessment.name,
        },
      }
    },
    fetchCount(){


      Notification.FetchAllCount(this.$store.state.auth.user.id).then((res)=>{
        this.count = res.response?.data?.unread_count
      })
    },
    showPage1(persistBy = "insertOrUpdate") {
      this.page = 1
      this.disableShowMore = false;
      this.showMore()
    },
    showMore(persistBy = "insertOrUpdate") {
      this.loading = true;
      Notification.FetchAll(
          this.$store.state.auth.user.id,
          {
            page: this.page,
            limit: this.limit,
          },
          {},
          [],
      )
          .then(({ response: { data: {meta, data }}}) => {
                this.meta = meta;
                this.loading = false;

                if (data.length > 0) {
                  this.page++;
                } else {
                  this.disableShowMore = true;
                }

              }
          ).catch(
          err => {
            this.handleError(err)
          }
      );
    },
  },
  mounted(){
    this.fetchCount()
    this.showMore()
  }
}
</script>

<style lang="scss">
.NotificationBell {

  position: relative;
  display: inline-block;

  .notification-dot {
    position: absolute;
    top: 0;
    right: 0;
    width: 10px;
    height: 10px;
    background-color: #f14668;
    border-radius: 50%;
  }
}
</style>